import { createContext } from "react";

export const TableColumnLayoutContext = createContext({
  widths: null,
  measuredWidths: null,
  lockColumnWidths: () => {},
  setColumnWidthAt: () => {},
});
